import { getAllRecipientsDeliveryIdentifiers } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import getEmailAddressFromString from './getEmailAddressFromString';
export const getAllRecipientsEmails = ({
  message
}) => {
  const allUnformattedRecipients = getAllRecipientsDeliveryIdentifiers(message).toArray();
  const allRecipients = allUnformattedRecipients.map(recipientAddressString => getEmailAddressFromString(recipientAddressString));
  return [...new Set(allRecipients)];
};